import { useEffect, useState } from "react";
import { extractPagesAsImages } from "../services/pdfService";

const renderThumbnailFromService = async (file: File): Promise<string> => {
  const result = await extractPagesAsImages(file);
  const firstPage = result.images[0];
  if (!firstPage?.base64_data) {
    return "";
  }

  return `data:image/${firstPage.format};base64,${firstPage.base64_data}`;
};

export const usePdfThumbnails = (files: File[]): string[] => {
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [previousFiles, setPreviousFiles] = useState(files);
  if (previousFiles !== files) {
    setPreviousFiles(files);
    setThumbnails([]);
  }

  useEffect(() => {
    let cancelled = false;
    // Clear after the previous effect's cleanup too: an old extraction may have
    // queued an update between the render reset and passive cleanup.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setThumbnails([]);

    if (files.length === 0) {
      return () => {
        cancelled = true;
      };
    }
    const run = async () => {
      const generated = await Promise.all(
        files.map(async (file) => {
          try {
            return await renderThumbnailFromService(file);
          } catch (error) {
            console.warn(`Thumbnail generation failed for ${file.name}`, error);
            return "";
          }
        })
      );

      if (!cancelled) {
        setThumbnails(generated);
      }
    };

    void run();

    return () => {
      cancelled = true;
    };
  }, [files]);

  return thumbnails;
};
